<div class="cl-shell">

  <app-navbar></app-navbar>

  <div class="cl-topbar"></div>

  <main class="cl-main">
    <div class="cl-wrapper">

      <div class="cl-header">
        <div>
          <div class="cl-eyebrow">Operations / Release Management</div>
          <h1 class="cl-page-title">Change Logs</h1>
          <p class="cl-page-desc">Track deployments, fixes, features and internal changes across OLS.</p>
        </div>
        <div class="cl-header-actions">
          <button mat-flat-button color="primary" class="cl-mat-primary" (click)="openAddModal()">
            <mat-icon fontSet="material-symbols-outlined">add</mat-icon>
            Add Entry
          </button>

          <div class="cl-profile-wrap" *ngIf="admin">
            <button type="button" class="cl-avatar-btn" (click)="toggleProfileMenu()" [class.open]="profileMenuOpen" title="Account">
              <img *ngIf="admin.picture" class="cl-profile-avatar" [src]="admin.picture" [alt]="admin.name || admin.email" referrerpolicy="no-referrer" />
              <span *ngIf="!admin.picture" class="cl-avatar-fallback">{{ (admin.name || admin.email || '?').charAt(0).toUpperCase() }}</span>
            </button>

            <div class="cl-profile-backdrop" *ngIf="profileMenuOpen" (click)="closeProfileMenu()"></div>

            <div class="cl-profile-menu" *ngIf="profileMenuOpen">
              <div class="cl-profile-menu-head">
                <img *ngIf="admin.picture" class="cl-profile-menu-avatar" [src]="admin.picture" [alt]="admin.name || admin.email" referrerpolicy="no-referrer" />
                <div class="cl-profile-menu-avatar cl-profile-menu-avatar-fallback" *ngIf="!admin.picture">
                  {{ (admin.name || admin.email || '?').charAt(0).toUpperCase() }}
                </div>
                <div class="cl-profile-menu-text">
                  <div class="cl-profile-menu-name">{{ admin.name || admin.email }}</div>
                  <div class="cl-profile-menu-email" *ngIf="admin.name">{{ admin.email }}</div>
                </div>
              </div>
              <mat-divider></mat-divider>
              <button type="button" class="cl-profile-menu-logout" (click)="logout()">
                <mat-icon fontSet="material-symbols-outlined">logout</mat-icon>
                Log out
              </button>
            </div>
          </div>
        </div>
      </div>

      <section class="cl-stats">
        <mat-card class="cl-kpi" appearance="outlined">
          <div class="cl-kpi-top">
            <span class="cl-kpi-label">Total changes</span>
            <span class="cl-kpi-icon cl-kpi-blue"><mat-icon fontSet="material-symbols-outlined">sync</mat-icon></span>
          </div>
          <div class="cl-kpi-value">{{ total }}</div>
          <div class="cl-kpi-note">{{ pageSize }} per page</div>
          <div class="cl-kpi-bar"><span style="width:100%"></span></div>
        </mat-card>

        <mat-card class="cl-kpi" appearance="outlined">
          <div class="cl-kpi-top">
            <span class="cl-kpi-label">Production</span>
            <span class="cl-kpi-icon cl-kpi-green"><mat-icon fontSet="material-symbols-outlined">verified</mat-icon></span>
          </div>
          <div class="cl-kpi-value">{{ productionCount }}</div>
          <div class="cl-kpi-note">{{ productionShareLabel }}</div>
          <div class="cl-kpi-bar cl-kpi-bar-green"><span [style.width.%]="entries.length ? (productionCount / entries.length * 100) : 0"></span></div>
        </mat-card>

        <mat-card class="cl-kpi" appearance="outlined">
          <div class="cl-kpi-top">
            <span class="cl-kpi-label">Features</span>
            <span class="cl-kpi-icon cl-kpi-indigo"><mat-icon fontSet="material-symbols-outlined">auto_awesome</mat-icon></span>
          </div>
          <div class="cl-kpi-value">{{ featureCount }}</div>
          <div class="cl-kpi-note">On this page</div>
          <div class="cl-kpi-bar cl-kpi-bar-indigo"><span [style.width.%]="entries.length ? (featureCount / entries.length * 100) : 0"></span></div>
        </mat-card>

        <mat-card class="cl-kpi" appearance="outlined">
          <div class="cl-kpi-top">
            <span class="cl-kpi-label">Last deployment</span>
            <span class="cl-kpi-icon cl-kpi-amber"><mat-icon fontSet="material-symbols-outlined">schedule</mat-icon></span>
          </div>
          <div class="cl-kpi-value">{{ lastDeploymentAge }}</div>
          <div class="cl-kpi-note">{{ lastDeploymentTitle }}</div>
          <div class="cl-kpi-bar cl-kpi-bar-amber"><span style="width:42%"></span></div>
        </mat-card>
      </section>

      <mat-card class="cl-toolbar-card" appearance="outlined">
        <div class="cl-toolbar-grid">
          <mat-form-field appearance="outline" class="cl-mat-field cl-search-field" subscriptSizing="dynamic">
            <mat-label>Search changes</mat-label>
            <mat-icon matPrefix fontSet="material-symbols-outlined">search</mat-icon>
            <input matInput placeholder="Title, summary, module or commit..." [(ngModel)]="filterSearch" (keyup.enter)="applyFilters()" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="cl-mat-field" subscriptSizing="dynamic">
            <mat-label>Commit type</mat-label>
            <mat-select [(ngModel)]="filterCommitType">
              <mat-option value="">All types</mat-option>
              <mat-option *ngFor="let t of commitTypes" [value]="t.id + ''">{{ t.name }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="cl-mat-field" subscriptSizing="dynamic">
            <mat-label>Environment</mat-label>
            <mat-select [(ngModel)]="filterEnvironment">
              <mat-option value="">All environments</mat-option>
              <mat-option value="production">Production</mat-option>
              <mat-option value="staging">Staging</mat-option>
              <mat-option value="develop">Develop</mat-option>
              <mat-option value="local">Local</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="cl-mat-field cl-range-field" subscriptSizing="dynamic">
            <mat-label>Date range</mat-label>
            <mat-date-range-input [rangePicker]="rangePicker">
              <input matStartDate placeholder="Start" name="clRangeStart" [(ngModel)]="filterDateFrom">
              <input matEndDate placeholder="End" name="clRangeEnd" [(ngModel)]="filterDateTo">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker>
              <mat-datepicker-actions>
                <button mat-button matDatepickerCancel>Cancel</button>
                <button mat-flat-button color="primary" matDatepickerApply>Apply</button>
              </mat-datepicker-actions>
            </mat-date-range-picker>
          </mat-form-field>

          <div class="cl-apply-wrap">
            <button mat-flat-button color="primary" class="cl-mat-primary" *ngIf="!filtersApplied" (click)="applyFilters()">Apply filters</button>
            <button mat-stroked-button *ngIf="filtersApplied" (click)="resetFilters()">Reset filters</button>
          </div>
        </div>

        <mat-divider></mat-divider>

        <div class="cl-toolbar-bottom">
          <mat-chip-set class="cl-chip-set" aria-label="Quick filters">
            <button mat-chip [highlighted]="activeChip === 'all'" (click)="quickFilter('all')">All changes</button>
            <button mat-chip [highlighted]="activeChip === 'production'" (click)="quickFilter('production')">Production</button>
            <button mat-chip *ngFor="let t of commitTypes" [highlighted]="activeChip === ('type:' + t.id)" (click)="quickFilter('type', t)">{{ t.name }}</button>
          </mat-chip-set>

          <div class="cl-view-toggle-wrap">
            <mat-button-toggle-group [value]="viewMode" (change)="switchView($event.value)" class="cl-view-toggle" hideSingleSelectionIndicator>
              <mat-button-toggle value="table">
                <mat-icon fontSet="material-symbols-outlined">table_rows</mat-icon>
                Table
              </mat-button-toggle>
              <mat-button-toggle value="timeline">
                <mat-icon fontSet="material-symbols-outlined">timeline</mat-icon>
                Timeline
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
      </mat-card>

      <div class="cl-alert" *ngIf="errorMessage">
        <mat-icon fontSet="material-symbols-outlined">error</mat-icon>
        {{ errorMessage }}
      </div>

      <mat-card class="cl-panel-card" appearance="outlined">
        <div class="cl-panel-head">
          <div>
            <div class="cl-panel-title">Deployment history</div>
            <div class="cl-panel-meta" *ngIf="!isLoading">Showing {{ displayedEntries.length }} of {{ total }} changes · Sorted by newest</div>
          </div>
          <div class="cl-panel-head-meta" *ngIf="!isLoading && total > 0">
            <mat-icon fontSet="material-symbols-outlined">dataset</mat-icon>
            Dataset view
          </div>
        </div>

        <div class="cl-loading" *ngIf="isLoading">
          <app-loader [fullscreen]="false" [backdrop]="false" size="md"></app-loader>
        </div>

        <ng-container *ngIf="!isLoading">
          <div class="cl-empty" *ngIf="displayedEntries.length === 0">
            <div class="cl-empty-icon">
              <mat-icon fontSet="material-symbols-outlined">description</mat-icon>
            </div>
            <ng-container *ngIf="!filtersApplied && !filterEnvironment; else filteredEmpty">
              <div class="cl-empty-title">No entries yet</div>
              <p class="cl-empty-text">Changes recorded by your team will appear here.</p>
              <button mat-flat-button color="primary" class="cl-mat-primary" (click)="openAddModal()">Add Entry</button>
            </ng-container>
            <ng-template #filteredEmpty>
              <div class="cl-empty-title">No matching entries</div>
              <p class="cl-empty-text">No entries match the current filters.</p>
              <button mat-stroked-button (click)="resetFilters()">Clear filters</button>
            </ng-template>
          </div>

          <div *ngIf="displayedEntries.length > 0 && viewMode === 'table'" class="cl-table-view">
            <div class="cl-table-wrap">
              <table mat-table [dataSource]="displayedEntries" class="cl-mat-table">

                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef>Date</th>
                  <td mat-cell *matCellDef="let entry" class="cl-date">
                    <strong>{{ formatDay(entry.change_datetime) }}</strong>
                    <span>{{ formatTime(entry.change_datetime) }}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="title">
                  <th mat-header-cell *matHeaderCellDef>Title</th>
                  <td mat-cell *matCellDef="let entry" class="cl-title-cell">
                    <strong>{{ entry.title }}</strong>
                    <span>{{ entry.summary }}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="environment">
                  <th mat-header-cell *matHeaderCellDef>Environment</th>
                  <td mat-cell *matCellDef="let entry">
                    <span class="cl-badge" [ngClass]="envBadgeClass(entry.environment.name)">
                      <span class="cl-dot"></span>{{ entry.environment.name }}
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef>Type</th>
                  <td mat-cell *matCellDef="let entry">
                    <span class="cl-badge" [ngClass]="commitTypeBadgeClass(entry.commit_type.name)">{{ entry.commit_type.name }}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="module">
                  <th mat-header-cell *matHeaderCellDef>Module</th>
                  <td mat-cell *matCellDef="let entry">{{ entry.module.name }}</td>
                </ng-container>

                <ng-container matColumnDef="commit">
                  <th mat-header-cell *matHeaderCellDef>Commit</th>
                  <td mat-cell *matCellDef="let entry">
                    <a *ngIf="entry.commit_link" class="cl-commit-link" [href]="entry.commit_link" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                      <mat-icon fontSet="material-symbols-outlined">open_in_new</mat-icon>
                      {{ commitLabel(entry.commit_link) }}
                    </a>
                    <span *ngIf="!entry.commit_link" class="cl-muted">—</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="author">
                  <th mat-header-cell *matHeaderCellDef>Author</th>
                  <td mat-cell *matCellDef="let entry">
                    <div class="cl-author">
                      <img *ngIf="authorPicture(entry)" class="cl-author-avatar cl-author-avatar-img" [src]="authorPicture(entry)" [alt]="entry.created_by.name || entry.created_by.email" referrerpolicy="no-referrer" />
                      <span *ngIf="!authorPicture(entry)" class="cl-author-avatar">{{ authorInitial(entry) }}</span>
                      <span>{{ entry.created_by.name || entry.created_by.email }}</span>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>Actions</th>
                  <td mat-cell *matCellDef="let entry" (click)="$event.stopPropagation()">
                    <div class="cl-row-actions">
                      <button mat-icon-button matTooltip="View details" (click)="openDetailDrawer(entry)">
                        <mat-icon fontSet="material-symbols-outlined">visibility</mat-icon>
                      </button>
                      <button mat-icon-button matTooltip="Edit" (click)="openEditModal(entry)">
                        <mat-icon fontSet="material-symbols-outlined">edit</mat-icon>
                      </button>
                      <button mat-icon-button color="warn" matTooltip="Delete" (click)="openDeleteConfirm(entry)">
                        <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let entry; columns: displayedColumns;" (click)="openDetailDrawer(entry)" class="cl-data-row"></tr>
              </table>
            </div>

            <div class="cl-mobile-cards">
              <mat-card class="cl-mobile-card" appearance="outlined" *ngFor="let entry of displayedEntries; trackBy: trackById" (click)="openDetailDrawer(entry)">
                <div class="cl-mc-top">
                  <h4>{{ entry.title }}</h4>
                  <span class="cl-badge" [ngClass]="commitTypeBadgeClass(entry.commit_type.name)">{{ entry.commit_type.name }}</span>
                </div>
                <p>{{ entry.summary }}</p>
                <div class="cl-mc-meta">
                  <span class="cl-badge" [ngClass]="envBadgeClass(entry.environment.name)">{{ entry.environment.name }}</span>
                  <a *ngIf="entry.commit_link" class="cl-commit-link" [href]="entry.commit_link" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">{{ commitLabel(entry.commit_link) }}</a>
                  <span>{{ formatDay(entry.change_datetime) }}</span>
                </div>
              </mat-card>
            </div>
          </div>

          <div class="cl-timeline" *ngIf="displayedEntries.length > 0 && viewMode === 'timeline'">
            <div class="cl-timeline-item" *ngFor="let entry of displayedEntries; trackBy: trackById" (click)="openDetailDrawer(entry)">
              <div class="cl-timeline-time">{{ formatDay(entry.change_datetime) }}<br>{{ formatTime(entry.change_datetime) }}</div>
              <div class="cl-timeline-track"><div class="cl-timeline-node"></div></div>
              <mat-card class="cl-timeline-card" appearance="outlined">
                <div class="cl-timeline-card-top">
                  <strong>{{ entry.title }}</strong>
                  <span class="cl-badge" [ngClass]="commitTypeBadgeClass(entry.commit_type.name)">{{ entry.commit_type.name }}</span>
                </div>
                <p>{{ entry.summary }}</p>
                <div class="cl-timeline-meta">
                  <span class="cl-badge" [ngClass]="envBadgeClass(entry.environment.name)"><span class="cl-dot"></span>{{ entry.environment.name }}</span>
                  <span>{{ entry.module.name }}</span>
                  <span>{{ entry.created_by.name || entry.created_by.email }}</span>
                </div>
              </mat-card>
            </div>
          </div>
        </ng-container>

        <div class="cl-footer" *ngIf="!isLoading && total > 0">
          <div class="cl-panel-meta">Showing {{ rangeStart }}–{{ rangeEnd }} of {{ total }} results</div>
          <div class="cl-pagination">
            <button mat-icon-button [disabled]="page <= 1" (click)="goToPage(page - 1)" aria-label="Previous">
              <mat-icon fontSet="material-symbols-outlined">chevron_left</mat-icon>
            </button>
            <button
              mat-stroked-button
              class="cl-page-btn"
              *ngFor="let p of pageButtons"
              [class.active]="p === page"
              [disabled]="p === '...'"
              (click)="onPageButtonClick(p)">{{ p }}</button>
            <button mat-icon-button [disabled]="page >= totalPages" (click)="goToPage(page + 1)" aria-label="Next">
              <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
            </button>
          </div>
        </div>
      </mat-card>

    </div>
  </main>

  <app-footer></app-footer>

  <div class="cl-modal-backdrop cl-detail-backdrop" *ngIf="detailModalOpen && detailEntry" (click)="closeDetailDrawer()">
    <div class="cl-detail-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
      <div class="cl-detail-hero">
        <div class="cl-detail-hero-text">
          <div class="cl-detail-kicker">Release detail</div>
          <h2>{{ detailEntry.title }}</h2>
          <p>{{ formatDay(detailEntry.change_datetime) }} · {{ formatTime(detailEntry.change_datetime) }}</p>
        </div>
        <button mat-icon-button class="cl-detail-close" (click)="closeDetailDrawer()" aria-label="Close">
          <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
        </button>
      </div>

      <div class="cl-detail-body">
        <div class="cl-drawer-badges">
          <span class="cl-badge" [ngClass]="envBadgeClass(detailEntry.environment.name)"><span class="cl-dot"></span>{{ detailEntry.environment.name }}</span>
          <span class="cl-badge" [ngClass]="commitTypeBadgeClass(detailEntry.commit_type.name)">{{ detailEntry.commit_type.name }}</span>
        </div>

        <div class="cl-detail-grid">
          <div class="cl-detail">
            <div class="cl-detail-label">
              <mat-icon fontSet="material-symbols-outlined">commit</mat-icon>
              Commit
            </div>
            <strong *ngIf="detailEntry.commit_link">
              <a class="cl-commit-link" [href]="detailEntry.commit_link" target="_blank" rel="noopener noreferrer">
                {{ commitLabel(detailEntry.commit_link) }}
                <mat-icon fontSet="material-symbols-outlined">open_in_new</mat-icon>
              </a>
            </strong>
            <strong *ngIf="!detailEntry.commit_link">—</strong>
          </div>
          <div class="cl-detail">
            <div class="cl-detail-label">
              <mat-icon fontSet="material-symbols-outlined">widgets</mat-icon>
              Module
            </div>
            <strong>{{ detailEntry.module.name }}</strong>
          </div>
          <div class="cl-detail">
            <div class="cl-detail-label">
              <mat-icon fontSet="material-symbols-outlined">person</mat-icon>
              Author
            </div>
            <div class="cl-author">
              <img *ngIf="authorPicture(detailEntry)" class="cl-author-avatar cl-author-avatar-img" [src]="authorPicture(detailEntry)" [alt]="detailEntry.created_by.name || detailEntry.created_by.email" referrerpolicy="no-referrer" />
              <span *ngIf="!authorPicture(detailEntry)" class="cl-author-avatar">{{ authorInitial(detailEntry) }}</span>
              <strong>{{ detailEntry.created_by.name || detailEntry.created_by.email }}</strong>
            </div>
          </div>
          <div class="cl-detail">
            <div class="cl-detail-label">
              <mat-icon fontSet="material-symbols-outlined">event</mat-icon>
              Deployed
            </div>
            <strong>{{ formatDay(detailEntry.change_datetime) }}, {{ formatTime(detailEntry.change_datetime) }}</strong>
          </div>
        </div>

        <div class="cl-detail cl-detail-block">
          <div class="cl-detail-label">
            <mat-icon fontSet="material-symbols-outlined">notes</mat-icon>
            Summary
          </div>
          <p class="cl-detail-summary">{{ detailEntry.summary }}</p>
        </div>

        <div class="cl-activity-section">
          <div class="cl-section-title">
            <mat-icon fontSet="material-symbols-outlined">history</mat-icon>
            Activity timeline
          </div>
          <div class="cl-activity">
            <div class="cl-activity-item">
              <strong>Deployed to {{ detailEntry.environment.name }}</strong>
              <span>{{ detailEntry.change_datetime | date:'MMM d, y • h:mm a' }}</span>
            </div>
            <div class="cl-activity-item" *ngIf="detailEntry.updated_by">
              <strong>Updated by {{ detailEntry.updated_by.name || detailEntry.updated_by.email }}</strong>
              <span>{{ detailEntry.updated_at | date:'MMM d, y • h:mm a' }}</span>
            </div>
            <div class="cl-activity-item">
              <strong>Entry created by {{ detailEntry.created_by.name || detailEntry.created_by.email }}</strong>
              <span>{{ detailEntry.created_at | date:'MMM d, y • h:mm a' }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="cl-detail-footer">
        <button mat-stroked-button (click)="closeDetailDrawer()">Close</button>
        <button mat-flat-button color="primary" class="cl-mat-primary" (click)="editFromDetail(detailEntry)">
          <mat-icon fontSet="material-symbols-outlined">edit</mat-icon>
          Edit Entry
        </button>
      </div>
    </div>
  </div>

  <div class="cl-modal-backdrop" *ngIf="modalOpen" (click)="closeModal()">
    <div class="cl-modal" (click)="$event.stopPropagation()">
      <div class="cl-modal-header">
        <div>
          <div class="cl-modal-title">{{ modalMode === 'add' ? 'Add Change Log Entry' : 'Edit Change Log Entry' }}</div>
          <p class="cl-modal-subtitle">Record a change so the rest of the team can track it.</p>
        </div>
        <button mat-icon-button (click)="closeModal()" aria-label="Close">
          <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
        </button>
      </div>

      <div class="cl-modal-body">
        <div class="cl-alert" *ngIf="submitError">
          <mat-icon fontSet="material-symbols-outlined">error</mat-icon>
          {{ submitError }}
        </div>

        <div class="cl-form-grid">
          <div class="cl-field cl-field-calendar">
            <app-calendar label="Date" placeholder="MM-DD-YYYY" [required]="true" [(ngModel)]="formChangeDate"></app-calendar>
            <div class="cl-field-error" *ngIf="fieldErrors.change_date">{{ fieldErrors.change_date }}</div>
          </div>

          <div class="cl-field">
            <mat-form-field appearance="outline" class="cl-mat-field">
              <mat-label>Time *</mat-label>
              <input matInput type="time" [(ngModel)]="formChangeTime" />
            </mat-form-field>
            <div class="cl-field-error" *ngIf="fieldErrors.change_time">{{ fieldErrors.change_time }}</div>
          </div>

          <div class="cl-field">
            <mat-form-field appearance="outline" class="cl-mat-field">
              <mat-label>Title *</mat-label>
              <input matInput [(ngModel)]="formTitle" />
            </mat-form-field>
            <div class="cl-field-error" *ngIf="fieldErrors.title">{{ fieldErrors.title }}</div>
          </div>

          <div class="cl-field">
            <label class="cl-label">Commit Type<span class="cl-req">*</span></label>
            <app-dropdownfield placeholder="Select type" [options]="commitTypeOptions" [(ngModel)]="formCommitTypeId"></app-dropdownfield>
            <div class="cl-field-error" *ngIf="fieldErrors.commit_type_id">{{ fieldErrors.commit_type_id }}</div>
          </div>

          <div class="cl-field cl-field-full">
            <mat-form-field appearance="outline" class="cl-mat-field">
              <mat-label>Commit / PR URL</mat-label>
              <input matInput placeholder="https://github.com/…" [(ngModel)]="formCommitLink" />
            </mat-form-field>
            <div class="cl-field-error" *ngIf="fieldErrors.commit_link">{{ fieldErrors.commit_link }}</div>
          </div>

          <div class="cl-field cl-field-full">
            <mat-form-field appearance="outline" class="cl-mat-field">
              <mat-label>Summary *</mat-label>
              <textarea matInput rows="4" [(ngModel)]="formSummary"></textarea>
            </mat-form-field>
            <div class="cl-field-error" *ngIf="fieldErrors.summary">{{ fieldErrors.summary }}</div>
          </div>
        </div>
      </div>

      <div class="cl-modal-footer">
        <button mat-stroked-button (click)="closeModal()">Cancel</button>
        <button mat-flat-button color="primary" class="cl-mat-primary" [disabled]="saving" (click)="saveEntry()">
          {{ saving ? 'Saving…' : 'Save Entry' }}
        </button>
      </div>
    </div>
  </div>

  <div class="cl-modal-backdrop" *ngIf="deleteConfirmOpen" (click)="closeDeleteConfirm()">
    <div class="cl-confirm-modal" (click)="$event.stopPropagation()">
      <div class="cl-confirm-icon">
        <mat-icon fontSet="material-symbols-outlined">warning</mat-icon>
      </div>
      <div class="cl-confirm-title">Delete change log?</div>
      <p class="cl-confirm-body">This removes the entry from the active change log. The record may still be retained internally.</p>
      <div class="cl-confirm-entry" *ngIf="deleteTarget">{{ deleteTarget.title }}</div>
      <div class="cl-modal-footer">
        <button mat-stroked-button [disabled]="deleting" (click)="closeDeleteConfirm()">Cancel</button>
        <button mat-flat-button color="warn" [disabled]="deleting" (click)="confirmDelete()">
          {{ deleting ? 'Deleting…' : 'Delete Entry' }}
        </button>
      </div>
    </div>
  </div>

</div>
